<template>
  <div id="mainDiv" v-if="viewFlag">
    <p style="text-align: center;margin-bottom: 2%;">
      <!-- 资源用户查询 -->
      <span class="systemFont1">{{
        $t("resourceUserQuery.resourceUser") + $t("common.query")
      }}</span>
    </p>
    <el-form
      :model="queryForm"
      label-position="right"
      ref="queryForm"
      label-width="100px"
      class="systemFont1"
      style="margin-left: 15px;"
    >
      <el-row style="min-width: 1030px">
        <!-- 个人用户检索入力框 -->
        <el-col :span="8">
          <el-form-item
            :label="$t('resourceUserQuery.userQuery')"
            prop="queryCriteria"
          >
            <el-input
              type="text"
              size="small"
              v-model="queryForm.queryCriteria"
              clearable
              :placeholder="$t('resourceUserQuery.searchPlaceholder')"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 标签 -->
        <el-col :span="7">
          <el-form-item
            :label="$t('resourceUserQuery.tag')"
            prop="tag"
          >
            <el-select
              v-model="queryForm.tagList"
              size="small"
              multiple
              style="width: 100%"
              :placeholder="$t('common.pleaseSelect')"
              clearable
            >
              <el-option
                v-for="item in tagOptList"
                :key="item.codeKey"
                :label="item.codeValue"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 绑定状态 -->
        <el-col :span="6">
          <el-form-item
            :label="$t('resourceUserQuery.bindingState')"
            prop="tag"
          >
            <el-select
              v-model="queryForm.bindingState"
              size="small"
              style="width: 100%"
              :placeholder="$t('common.pleaseSelect')"
              clearable
            >
              <el-option
                v-for="item in stateOptList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="min-width: 1030px">
        <!-- 区域 -->
        <el-col :span="15">
          <el-form-item :label="$t('resourceUserQuery.region')" prop="country">
            <RegionQuery ref="RegionQueryRef" :formData="queryForm"/>
          </el-form-item>
        </el-col>
        <!-- 分区 -->
        <el-col :span="6">
          <el-form-item
            :label="$t('resourceUserQuery.subarea')"
            prop="subarea"
          >
            <el-input
              type="text"
              size="small"
              v-model="queryForm.subarea"
              clearable
              :placeholder="$t('resourceUserQuery.searchKey')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="min-width: 1030px">
        <!-- 所属机构 -->
        <el-col :span="6">
          <el-form-item
            :label="$t('resourceUserQuery.affiliation')"
            prop="tag"
          >
            <el-select
              v-model="queryForm.institution"
              size="small"
              style="width: 100%"
              :placeholder="$t('common.pleaseSelect')"
              clearable
            >
              <el-option
                v-for="item in institutionOptList"
                :key="item.codeKey"
                :label="item.codeValue"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="width: 210px;">
          <div>
            <!-- 查询 -->
            <el-button
              class="submitButton"
              style="width:80px;margin-left:35px"
              type="submit"
              @click="getUserDetail(true)"
              >{{ $t("common.search") }}</el-button
            >
            <!-- 重置 -->
            <el-button class="buttonWidth" type="submit" @click="reset">{{
              $t("common.reset")
            }}</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <div style=" padding:17px 0 15px 0;float: left; ">
        <!-- 资源用户导入 -->
        <el-button
          class="submitButton"
          style="width: 100px"
          type="submit"
          @click="handleUserImport()"
        >{{ $t("resourceUserQuery.resourceUserImport") }}</el-button>
        <!-- 设置标签 -->
        <el-button
          class="submitButton"
          style="width: 100px"
          type="submit"
          @click="handleSetTag()"
          :disabled="!(ids && ids.length>0)"
        >{{$t("resourceUserQuery.setTag")}}</el-button>
        <!-- 设置区域 -->
        <el-button
          class="submitButton"
          style="width: 100px"
          type="submit"
          :disabled="!(ids && ids.length>0)"
          @click="handleSetArea()"
        >{{ $t("resourceUserQuery.setArea") }}</el-button >
        <!-- 注册二维码下载 -->
        <el-button
          class="submitButton"
          style="width: 100px"
          type="submit"
          @click="handleQRCode()"
        >{{ $t("resourceUserQuery.qRCodeDownload") }}</el-button>
      </div>
    </el-row>
    <el-row style="min-width: 1030px">
      <el-col>
        <el-table
          ref="userDetailTable"
          :data="individualUserDetails"
          v-loading="pageLoading"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          :row-key="(item) => item.userId"
        >
        <el-table-column
          type="selection"
          width="50"
          align="center"
          fixed="left"
          :reserve-selection="true"
        />
          <!-- 头像 -->
          <!-- <el-table-column
            :label="$t('resourceUserQuery.headPortrait')"
            align="center"
            min-width="70"
          >
            <template slot-scope="scope">
              <el-avatar
                :src="viewHeadPortrait(scope.row.headPortrait)"
                :key="scope.row.headPortrait"
                :size="30"
              ></el-avatar>
            </template>
          </el-table-column> -->
          <!-- 姓名-->
          <el-table-column
            prop="name"
            :label="$t('resourceUserQuery.userName')"
            align="left"
            fixed="left"
            min-width="110"
          ></el-table-column>
          <!-- 英文姓名 -->
          <!-- <el-table-column
            prop="englishName"
            :label="$t('resourceUserQuery.englishName')"
            align="left"
            min-width="120"
          ></el-table-column> -->
          <!-- 昵称 -->
          <!-- <el-table-column
            prop="nickName"
            :label="$t('resourceUserQuery.nickname')"
            align="left"
            min-width="100"
          ></el-table-column> -->
          <!-- 手机 -->
          <el-table-column
            prop="phone"
            :label="$t('resourceUserQuery.phone')"
            align="center"
            min-width="130"
          ></el-table-column>
          <!-- 邮箱 -->
          <el-table-column
            prop="email"
            :label="$t('resourceUserQuery.email')"
            align="left"
            min-width="200"
          ></el-table-column>
          <!-- 关联公司 -->
          <!-- <el-table-column
            prop="existingCompany"
            :label="$t('resourceUserQuery.existingCompany')"
            align="left"
            min-width="120"
          ></el-table-column> -->
          <!-- 职位 -->
          <!-- <el-table-column
            prop="position"
            :label="$t('p0211.position')"
            align="left"
            min-width="100"
          ></el-table-column> -->
          <!-- 绑定状态 -->
          <el-table-column
            :label="$t('resourceUserQuery.bindingState')"
            align="center"
            prop="bindingState"
            min-width="90"
          >
            <template slot-scope="scope">
              <span :style="`color: ${statusFormat(scope.row).color}`">
                {{ statusFormat(scope.row).value }}
              </span>
            </template>
          </el-table-column>
          <!-- 标签 -->
          <el-table-column
            prop="tag"
            :label="$t('resourceUserQuery.tag')"
            align="left"
            min-width="160"
          ></el-table-column>
          <!-- 区域 -->
          <el-table-column
            prop="region"
            :label="$t('resourceUserQuery.region')"
            align="left"
            min-width="200"
          >
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.userLocationList" :key="'region'+index">
                {{item.countryName}}{{item.provinceName}}{{item.cityName}}{{item.areaName}}
              </div>
            </template>
          </el-table-column>
          <!-- 分区 -->
          <el-table-column
            prop="subarea"
            :label="$t('resourceUserQuery.subarea')"
            align="left"
            min-width="140"
          ></el-table-column>
          <!-- 所属机构 -->
          <el-table-column
            prop="institution"
            :label="$t('resourceUserQuery.affiliation')"
            align="left"
            min-width="220"
          ></el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="60"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- 详细 -->
              <el-button
                type="text"
                @click="
                  detail(
                    scope.row,
                    scope.row.userId,
                    scope.row.documentAppendix01,
                    scope.row.documentAppendix02
                  )
                "
                >&nbsp;{{ $t("resourceUserQuery.details") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <el-row style="text-align: right; margin: 20px">
      <el-col :span="24">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10,20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-row><br /></el-row>
    <!-- 资源用户导入 -->
    <el-dialog :visible.sync="importVisible" width="385px" center :close-on-click-modal="false">
      <el-row style="text-align: center; margin-top: 15.3px">
        <el-col :span="12">
          <!-- 下载模板 -->
          <el-button type="p0322Button" @click="downloadTemplate()">{{
            $t("p0332.downloadTemplate")
          }}</el-button>
        </el-col>
        <el-col :span="12">
          <!-- 上传模板 -->
          <el-upload
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="uploadTemplate"
            ref="xlsxTamplate"
          >
            <el-button type="p0322Button">{{
              $t("p0332.uploadTemplate")
            }}</el-button>
          </el-upload>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 设置标签 -->
    <el-dialog
      :title="$t('resourceUserQuery.setTag')"
      :visible.sync="setTagVisible"
      :before-close="cancelTag"
      width="485px"
      style="text-align: left;"
      :close-on-click-modal="false"
    >
      <el-form
        :model="tagForm"
        :rules="tagRulers"
        ref="tagFromRef"
        label-width="auto"
      >
        <!-- 标签 -->
        <el-form-item
          :label="$t('resourceUserQuery.tag')"
          prop="tagList"
        >
        <el-select
          v-model="tagForm.tagList"
          size="small"
          multiple
          style="width: 100%"
          :placeholder="$t('common.pleaseSelect')"
          clearable
        >
          <el-option
            v-for="item in tagOptList"
            :key="item.codeKey"
            :label="item.codeValue"
            :value="item.codeKey"
          >
          </el-option>
        </el-select>
        </el-form-item>
        <!-- 重置标签 -->
          <el-form-item :label="$t('resourceUserQuery.resetTag')" prop="resetTag">
            <el-radio-group v-model="tagForm.resetTag">
              <el-radio :label="1">{{ $t("common.yes") }}</el-radio>
              <el-radio :label="2">{{ $t("common.not") }}</el-radio>
            </el-radio-group>
          </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <!-- 提交 -->
        <el-button type="submit" @click="submitTag()">{{ $t("common.submit") }}</el-button>
        <!-- 取消 -->
        <el-button type="return" @click="cancelTag()">{{ $t("common.cancel") }}</el-button>
      </div>
    </el-dialog>
    <!-- 设置区域 -->
    <el-dialog
      :title="$t('resourceUserQuery.setArea')"
      :visible.sync="setAreaVisible"
      :before-close="cancelArea"
      @opened="openedArea"
      width="485px"
      style="text-align: left;"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form
        :hide-required-asterisk="false"
        :model="areaForm"
        :rules="areaRulers"
        ref="areaFormRef"
        label-width="auto"
        class="downloadCodeClass"
      >
        <!-- 区域 -->
        <el-form-item :label="$t('resourceUserQuery.region')" prop="country">
          <RegionListSelection v-if="setAreaVisible" ref="RegionSelectionRef" :formData="areaForm"/>
        </el-form-item>
        <!-- 分区 -->
        <el-form-item :label="$t('resourceUserQuery.subarea')" prop="subarea">
          <el-input
            type="text"
            size="small"
            v-model="areaForm.subarea"
            clearable
            :placeholder="$t('resourceUserQuery.enterSubarea')"
          ></el-input>
        </el-form-item>
        <!-- 所属机构 -->
        <el-form-item
          :label="$t('resourceUserQuery.affiliation')"
          prop="institution"
        >
        <el-select
          v-model="areaForm.institution"
          size="small"
          style="width: 100%"
          :placeholder="$t('common.pleaseSelect')"
          clearable
        >
          <el-option
            v-for="item in institutionOptList"
            :key="item.codeKey"
            :label="item.codeValue"
            :value="item.codeKey"
          >
          </el-option>
        </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <!-- 提交 -->
        <el-button type="submit" @click="submitArea()">{{ $t("common.submit") }}</el-button>
        <!-- 取消 -->
        <el-button type="return" @click="cancelArea()">{{ $t("common.cancel") }}</el-button>
      </div>
    </el-dialog>
    <!-- 下载二维码 -->
    <el-dialog
      :title="$t('resourceUserQuery.downloadCodeTitle')"
      :visible.sync="qrCodeVisible"
      :before-close="cancelCode"
      @opened="openedQrCode"
      :append-to-body="true"
      width="485px"
      style="text-align: left;"
      :close-on-click-modal="false"
    >
      <el-form
        :model="qrCodeForm"
        :rules="qrCodeRulers"
        ref="qrCodeFormRef"
        label-width="auto"
        class="downloadCodeClass"
      >
        <!-- 标签 -->
        <el-form-item
          :label="$t('resourceUserQuery.tag')"
          prop="tagList"
        >
        <el-select
          v-model="qrCodeForm.tagList"
          size="small"
          multiple
          style="width: 100%"
          :placeholder="$t('common.pleaseSelect')"
          clearable
          @change="tagChange"
        >
          <el-option
            v-for="item in tagOptList"
            :key="item.codeKey"
            :label="item.codeValue"
            :value="item.codeKey"
          >
          </el-option>
        </el-select>
        </el-form-item>
        <!-- 区域 -->
        <el-form-item :label="$t('resourceUserQuery.region')" prop="country">
          <RegionListSelection v-if="qrCodeVisible" ref="RegionQrCodeRef" :formData="qrCodeForm"/>
        </el-form-item>
        <!--分区-->
        <el-form-item
          :label="$t('resourceUserQuery.subarea')"
          prop="subarea"
        >
          <el-input
            type="text"
            size="small"
            v-model="qrCodeForm.subarea"
            clearable
            :placeholder="$t('resourceUserQuery.enterSubarea')"
          ></el-input>
        </el-form-item>
        <!-- 所属机构 -->
        <el-form-item
          :label="$t('resourceUserQuery.affiliation')"
          prop="institution"
        >
        <el-select
          v-model="qrCodeForm.institution"
          size="small"
          style="width: 100%"
          :placeholder="$t('common.pleaseSelect')"
          clearable
        >
          <el-option
            v-for="item in institutionOptList"
            :key="item.codeKey"
            :label="item.codeValue"
            :value="item.codeKey"
          >
          </el-option>
        </el-select>
        </el-form-item>
        <!--备注-->
        <el-form-item
          :label="$t('resourceUserQuery.remarks')"
          prop="remarks"
        >
          <el-input
            type="text"
            size="small"
            v-model="qrCodeForm.remarks"
            clearable
            :placeholder="$t('resourceUserQuery.enterRemarks')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <!-- 下载 -->
        <el-button type="submit" @click="submitDownloadCode()">{{ $t("resourceUserQuery.download") }}</el-button>
        <!-- 取消 -->
        <el-button type="return" @click="cancelCode()">{{ $t("common.cancel") }}</el-button>
      </div>
    </el-dialog>
    <!-- 错误信息 -->
    <el-dialog
      :visible.sync="errListVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="dialog"
    >
      <el-table :data="errMsgList" style="margin-bottom: 75px">
        <el-table-column :label="$t('resourceUserQuery.errorMessage')" align="center" class="errdialog">
          <template slot-scope="scope">
            <span class="errdialog">{{ scope.row }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import RegionQuery from "./RegionQuery.vue"
import RegionListSelection from "./RegionListSelection.vue"
import tag from "element-ui/packages/tag";
export default {
  components: {
    RegionListSelection,
    RegionQuery,
  },
  data() {
    var checkLength = (rule,value,callback)=>{
      const len = value.match(/[^ -~]/g) == null ? value.length : value.length + value.match(/[^ -~]/g).length;
      if(len>80){
        return callback(new Error(this.$t("resourceUserQuery.msg1")));
      }
      return callback()
    };
    // 验证规则 - 所属机构
    const checkInstitution = (rule, value, callback) => {
      if (!value) {
        if (this.qrCodeForm.tagList !="" && this.qrCodeForm.tagList !=null && this.qrCodeForm.tagList.length>0) {
          if (this.qrCodeForm.tagList.includes("3")) {
            callback(new Error(this.$t("resourceUserQuery.affiliationEnterMsg")));
          }
        }
      }
      callback();
    };
    return {
      tableKey: "random_string",
      // 查询条件
      queryForm: {
        queryCriteria: "",
        tagList: [],
        tag: "",
        country: '',
        province: '',
        city: '',
        area: '',
        subarea: '',
        bindingState: '',
        institution: '',
      },
      // 个人用户一览
      individualUserDetails: [],
      // 标签下拉列表
      tagOptList: [],
      // 区域下拉
      regionOptList: [],
      // 所属机构
      institutionOptList: [],
      // 页面载入状态
      pageLoading: false,
      viewFlag: true,
      // 当前页
      currentPage: 1,
      // 每页件数
      pageSize: 10,
      total: 0,
      amount: "",
      // 默认头像图片
      defaultImg: require("../../../assets/headPortrait.png"),
      // 检索条件保持变量
      tmpQueryStr: {
        queryCriteria: "",
        tagList: [],
        tag: "",
        country: '',
        province: '',
        city: '',
        area: '',
        subarea: '',
        bindingState: '',
      },
      // 导入弹窗显示
      importVisible: false,
      // 下载二维码弹窗显示
      qrCodeVisible: false,
      // 设置标签弹窗显示
      setTagVisible: false,
      // 设置区域弹窗显示
      setAreaVisible: false,
      // 设置标签表单
      tagForm: {
        tagList:[],
        resetTag: 1,
        idsList: [],
      },
      areaForm: {
        country: '',
        province: '',
        city: '',
        area: '',
        subarea: '',
        institution: '',
        idsList: [],
      },
      qrCodeForm: {
        tagList:[],
        country: '',
        province: '',
        city: '',
        area: '',
        subarea: '',
        idsList: [],
        remarks:'',
        institution: '',
      },
      ids: [],
      // 错误弹窗是否显示
      errListVisible: false,
      // 错误信息
      errMsgList: [],
      // 绑定状态下拉列表
      stateOptList: [
        // 未绑定
        {key: '0', value: this.$t('resourceUserQuery.notBound'),color: '#FD5B4D'},
        // 已绑定
        {key: '1', value: this.$t('resourceUserQuery.bound'),color: '#02D764'},
      ],
      // 设置标签校验
      tagRulers:{
        tagList: [
          { required: true,  message: this.$t("common.pleaseSelect"), trigger: ["blur", "change"] }
        ],
      },
      areaRulers:{
        country: [
          { required: true,  message: this.$t("common.pleaseSelect"), trigger: ["blur", "change"] }
        ],
        institution: [
          { required: true,  message: this.$t("common.pleaseSelect"), trigger: ["blur", "change"] }
        ],
      },
      qrCodeRulers:{
        tagList: [
          { required: true,  message: this.$t("common.pleaseSelect"), trigger: ["blur", "change"] }
        ],
        country: [
          { required: true,  message: this.$t("common.pleaseSelect"), trigger: ["blur", "change"] }
        ],
        institution: [
          { required: false, validator: checkInstitution, trigger: "" },
        ],
        // institution: [
        //   { required: true,  message: this.$t("common.pleaseSelect"), trigger: ["blur", "change"] }
        // ],
        remarks:[{required: false,validator: checkLength,trigger:'change'}]
      }
    };

  },
  created() {
  },
  async mounted() {
    if (sessionStorage.getItem("detail")) {
      await this.getSchoolWebModuleMessageListFunc();
    } else {
      this.getTagList()
      this.getInstitutionOptList()
      this.$refs.RegionQueryRef.getChineArea()
      this.getUserDetail(true);
    }
  },
  methods: {
    /** 标签下拉列表获取 */
    getTagList(){
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/resourceUserQuery/getTagOptList";
      this.$http
        .get(url)
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.tagOptList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
          loading.close();
        });
    },
    getInstitutionOptList(){
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/resourceUserQuery/getInstitutionOptList";
      this.$http
        .get(url)
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.institutionOptList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
          loading.close();
        });
    },

    /** 绑定状态获取 */
    statusFormat(row) {
      return this.stateOptList.find(item => item.key === row.bindingState)
    },
    /** 重置 */
    reset() {
      this.$refs.queryForm.resetFields();
      this.queryForm= {
        queryCriteria: "",
        tagList: [],
        tag: "",
        country: '',
        province: '',
        city: '',
        area: '',
        subarea: '',
        bindingState: '',
        institution: '',
      },
      this.tmpQueryStr = this.queryForm;
      this.$refs.RegionQueryRef.clearProvince()
      this.getUserDetail(false);
    },
    // 个人用户一览检索
    getUserDetail(val) {
      this.pageLoading = true;
      if (val) {
        this.currentPage = 1;
        this.total = 0;
        this.tmpQueryStr = this.queryForm;
      }
      // 换页时，检索条件还原
      this.queryForm = this.tmpQueryStr;
      let url = "/api/resourceUserQuery/getResourceUserList";
      this.$http
        .post(
          url,
          {
            ...this.tmpQueryStr,
            currentSize: (this.currentPage - 1) * this.pageSize,
            pageSize: this.pageSize,
            total: this.total
          }
        )
        .then(response => {
          this.pageLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.individualUserDetails = response.data.data;
            //判断是否初始化
            if (this.currentPage == 1) {
              this.individualUserDetails = response.data.data;
              this.total = this.individualUserDetails[0].total;
            } else {
              this.individualUserDetails = response.data.data;
            }
          } else {
            this.individualUserDetails = [];
            // this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.pageLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 个人用户详细信息取得
    detail(idx, userId) {
      let p0212 = JSON.stringify({
        userID: userId,
        locationCode1: idx.documentAppendix01,
        locationCode2: idx.documentAppendix02,
        currentPage: this.currentPage,
        imageBase64: idx.headPortrait
      });
      sessionStorage.p0212 = p0212;
      sessionStorage.setItem("total", this.total);
      sessionStorage.setItem("pageSize", this.pageSize);
      let query = JSON.stringify({
        queryCriteria: this.tmpQueryStr.queryCriteria,
        tag: this.tmpQueryStr.tag,
        tagList: this.tmpQueryStr.tagList,
        country: this.tmpQueryStr.country,
        province: this.tmpQueryStr.province,
        city: this.tmpQueryStr.city,
        area: this.tmpQueryStr.area,
        subarea: this.tmpQueryStr.subarea,
        bindingState: this.tmpQueryStr.bindingState,
      });
      sessionStorage.setItem("queryCriteria", query);
      sessionStorage.setItem("regionOptList", JSON.stringify(this.regionOptList));
      sessionStorage.setItem("tagOptList", JSON.stringify(this.tagOptList));
      sessionStorage.setItem("institutionOptList", JSON.stringify(this.institutionOptList));
      // 跳转指定页面
      this.$router.push({
        path: "/views/CustomerInfoBase/P0213"
      });
    },
    // 头像图片显示
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.individualUserDetails == undefined ||
        this.individualUserDetails.length <= 0
      ) {
        return;
      }
      this.getUserDetail(false);
      // console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserDetail(false);
      // console.log(`当前页: ${val}`);
    },
    //返回跳转前的页面
    async getSchoolWebModuleMessageListFunc() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值，用以返回前的页面，保持不变
      if (sessionStorage.getItem("detail")) {
        //如果有这个就读取缓存里面的数据
        this.currentPage = Number(sessionStorage.getItem("currentPage"));
        this.total = Number(sessionStorage.getItem("total"));
        this.pageSize = Number(sessionStorage.getItem("pageSize"));
        this.tmpQueryStr = JSON.parse(sessionStorage.getItem("queryCriteria"));
        this.regionOptList = JSON.parse(sessionStorage.getItem("regionOptList"));
        this.tagOptList = JSON.parse(sessionStorage.getItem("tagOptList"));
        this.institutionOptList = JSON.parse(sessionStorage.getItem("institutionOptList"));
        this.getUserDetail(false);
        await this.$refs.RegionQueryRef.getChineArea()
        sessionStorage.removeItem("detail");
      } else {
        this.currentPage = 1;
        //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
        sessionStorage.removeItem("currentPage");
        sessionStorage.removeItem("total");
      }
      loading.close()
    },
    /** 选择条数  */
    handleSelectionChange(selection) {
      this.ids = selection;
    },
    /** 打开资源用户导入弹窗 */
    handleUserImport(){
      this.importVisible = true
    },
    /** 下载导入模板 */
    downloadTemplate(){
      this.importVisible = false;
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/resourceUserQuery/downloadTemplate";
      this.$http
        .get(url, { responseType: "blob" })
        .then(response => {
          // console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          // console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            this.$message.error(this.$t("resourceUserQuery.existTemplate"));
            loading.close();
          } else {
            const fileName = this.$t("resourceUserQuery.resourceUserTemplate");
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              // console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("resourceUserQuery.errorTemplate"));
          loading.close();
        });
    },
    //上传模板
    uploadTemplate(file) {
      this.importVisible = false;
      this.$refs.xlsxTamplate.clearFiles();
      if (this.beforeAvatarUploadTemplate(file.raw)) {
        this.uploadFile = file.raw;
        const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        let templatefiles = new FormData();
        templatefiles.append("file", this.uploadFile);
        templatefiles.append(
          "createUser",
          JSON.stringify(localStorage.userId)
        );
        let url = "/api/resourceUserQuery/uploadTemplate";
        this.$http
          .post(url, templatefiles)
          .then(response => {
            this.formVisible = false;
            if (response.data.code === 200) {
              if (response.data.data.length == 0) {
                this.errListVisible = false,
                this.$message.success(this.$t("resourceUserQuery.successTemplate"));
                this.getUserDetail(false);
              } else {
                this.errListVisible = true,
                this.errMsgList = response.data.data;
                // console.log("错误信息：" + response.data.data);
              }
              loading.close();
            } else {
              loading.close();
              this.$message.error(response.data.message);
            }
            loading.close();
          })
          .catch(err => {
            loading.close();
            console.log(err);
            this.$message.error(this.$t("resourceUserQuery.importFailure"));
          });
      }
    },
    beforeAvatarUploadTemplate(file) {
      // console.log(file);
      // 设置文件类型
      var i = file.name.substring(file.name.lastIndexOf(".") + 1);
      // console.log(i);
      const isXLS = i === "xlsx" || i === "xls";
      // console.log(isXLS);
      if (!isXLS) {
        this.$message.error(this.$t("resourceUserQuery.templateTypeErr"));
      }
      return isXLS;
    },
    /** 打开设置标签弹窗 */
    handleSetTag(){
      this.setTagVisible = true
      this.tagForm.idsList = this.ids
    },
    /** 设置标签弹窗--提交 */
    submitTag(){
      this.$refs["tagFromRef"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/resourceUserQuery/submitTag";
          this.tagForm.updateUser = localStorage.userId
          this.$http
            .post(url, this.tagForm)
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success(this.$t("resourceUserQuery.submitSuccess"));
                // 清除勾选
                this.$refs.userDetailTable.clearSelection();
                // 查询一览
                this.getUserDetail(false);
                // 关闭弹窗
                this.cancelTag();
                loading.close();
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
              loading.close();
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("resourceUserQuery.errorOccurred"));
            });
        }
      });
    },
    /** 设置标签弹窗-取消 */
    cancelTag(){
      // 入力项目清空
      this.$refs["tagFromRef"].resetFields();
      this.tagForm={
        tagList:[],
        resetTag: 1,
        idsList: [],
      }
      this.setTagVisible = false
    },
    openedArea(){
      this.$refs.RegionSelectionRef.getChineArea()
    },
    /** 打开设置区域弹窗 */
    handleSetArea(){
      this.areaForm.idsList = this.ids
      this.setAreaVisible = true
    },
    /** 设置区域弹窗--提交 */
    submitArea(){
      this.$refs["areaFormRef"].validate(valid => {
        if (valid) {
          // 省市区必填校验
          let regionFlag = false
          this.$refs.RegionSelectionRef.$refs.formDataRef.validateField(['country', 'province', 'city', 'area'], val => {
            if (val) {
              regionFlag = true;
            }
          })
          if(regionFlag){
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/resourceUserQuery/submitArea";
          this.areaForm.updateUser = localStorage.userId
          this.$http
            .post(url, this.areaForm)
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success(this.$t("resourceUserQuery.submitSuccess"));
                this.$refs.userDetailTable.clearSelection();
                this.getUserDetail(false);
                this.cancelArea();
                loading.close();
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
              loading.close();
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("resourceUserQuery.errorOccurred"));
            });
        }
      });
    },
    cancelArea(){
      // 入力项目清空
      this.$refs["areaFormRef"].resetFields();
      this.areaForm={
        country: '',
        province: '',
        city: '',
        area: '',
        subarea: '',
        idsList: [],
      }
      this.setAreaVisible = false
    },
    /** 注册二维码获取区域下拉 */
    openedQrCode(){
      this.$refs.RegionQrCodeRef.getChineArea()
    },
    /** 打开注册二维码下载弹窗 */
    handleQRCode(){
      this.qrCodeVisible = true
    },
    filesName() {
      let tags = this.qrCodeForm.tagList
          .map((item, index) => {
            const foundItem = this.tagOptList.find(tags => tags.codeKey === item);
            return foundItem ? foundItem.codeValue : ''; // 如果找到了对应的项，则返回其 codeValue，否则返回空字符串
          })
          .join(';').replace('/','');
      let region = this.$refs.RegionQrCodeRef.selectRegionString();
      return {tagsTitle: tags, regionTitle: region};
    },
    /** 下载二维码 */
    submitDownloadCode(){
      this.$refs["qrCodeFormRef"].validate(valid => {
        if (valid) {
          // 省市区必填校验
          let regionFlag = false
          this.$refs.RegionQrCodeRef.$refs.formDataRef.validateField(['province', 'city', 'area'], val => {
            if (val) {
              regionFlag = true;
            }
          })
          if(regionFlag){
            return;
          }
          const loading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          background: "rgba(255,255,255,0.8)",
          target: document.querySelector("#main-container")
        });
        let url = "/api/resourceUserQuery/getDownloadCode";
        this.qrCodeForm.tag = JSON.stringify(this.qrCodeForm.tagList);
        this.qrCodeForm.createUser = localStorage.userId
        let names = this.filesName();
        let filesName = '[' + names.tagsTitle + ' - ' + names.regionTitle + ']'
        this.$http
          .post(
            url,
            {
              ...this.qrCodeForm,
              tagsTitle: names.tagsTitle,
              regionTitle: names.regionTitle
            },
            {
              responseType: "blob"
            }
          )
          .then(response => {
            // 文件名
            const fileName = this.$t("resourceUserQuery.registerResourceCode")+filesName+".jpg";
            const fileStream = response.data; // 返回文件流
            const blob = new Blob([fileStream]);
            // 使用dom a 下载图片
            const a = document.createElement("a");
            const href = window.URL.createObjectURL(blob); // 创建下载连接
            a.href = href;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a); // 下载完移除元素
            window.URL.revokeObjectURL(href); // 释放掉blob对象
            loading.close();
            this.cancelCode()
          })
          .catch(err => {
            console.log(err);
            loading.close();
            this.$message.error(this.$t("common.anErrorOccurred"));
          });
        }
      });
    },
    /** 取消下载二维码  */
    cancelCode(){
      // 入力项目清空
      this.$refs["qrCodeFormRef"].resetFields();
      this.qrCodeForm={
        tagList:[],
        country: '',
        province: '',
        city: '',
        area: '',
        subarea: '',
        idsList: [],
        remarks: ''
      }
      this.qrCodeVisible = false
    },
    // 标签变更时处理
    tagChange() {
      this.$refs.qrCodeFormRef.validateField(['institution'])
    },

  }
};
</script>

<style lang="scss" scoped>
#mainDiv {
  width: 94%;
  padding-left: 3%;
  // padding-top: 1%;
  // border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-form-item {
  margin-bottom: 5px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

// >>> .el-form-item__label {
//   font-size: 16px;
//   font-weight: bold;
//   color: #333333;
// }
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
// >>>.el-table .cell{
//   // line-height: 30px;
//   // height: 30px;
// }
>>> .el-table .el-table__cell {
  // padding: 8.5px 0;
  padding-top: 8.5px;
  padding-bottom: 1.5px;
}

// 取消input的上下箭头
>>> input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

>>> input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}
// 错误弹窗样式
.errdialog {
  height: 15px;
  border-color: rgb(204, 204, 204);
  font-size: 16px;
  font-family: Microsoft YaHei;
  padding: 7px 0;
}
.downloadCodeClass{
  >>> .el-form-item__content{
    line-height: 45px;
  }
  >>> .el-form-item__error{
    padding-top: 0px;
  }
}
.dialog {
  width: 1280px;
  text-align: center;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  >>> .el-dialog {
    margin: 0 auto !important;
    max-height: 80%;
    height: 80%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 15px;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
    >>> .el-table .el-table__cell {
      padding: 7px 0;
    }
  }
}
.submitButton {
  height: 32px;
  margin-top: 4px;
}
>>> .buttonWidth {
  width: 80px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}
</style>




// WEBPACK FOOTER //
// src/views/ResourceBaseManagement/ResourceUser/Index.vue